<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RLGjAb/tc-custom/9781625850713.jpg?1705234660121" alt="This image is the cover for the book Nashville Food Trucks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nashville Food Trucks
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“A guide to the chefs and food making up Nashville’s vibrant rolling restaurant scene . . . stalker-worthy trucks offer comfort food and Southern favorites.” —<i>Tennessean</i></b></p> Nashville’s best eats have been brought to the streets. The city’s booming food truck trend is part of what makes central Tennessee a culinary destination and a hub for all things food. These mobile menus have earned foodie favoritism and serve up more than just the good ol’ southern comfort stuff. Folks are lining up for a wide array of gourmet grub inspired by all kinds of different cuisines and tastes. Local trucks have been featured on the Cooking Channel’s “Eat Street” and “Unique Eats,” and Nashville is home to major annual food truck events, like the Nashville Street Food Awards and Musician’s Corner. Dig in to these palatable pages with award-winning NashvilleFoodTruckJunkie.com blogger, Julie Festa, who dishes out the details about the city’s traveling eateries and the chefs and inspired recipes behind them.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julie Festa, Brooke Stevens
      </h2>
      
      <p class="authorDescription body article">Julie Festa is Nashville's premiere food truck blogger, having created and run NashvilleFoodTruckJunkie.com since 2012. She keeps up with the locations and reviews the trucks to help Middle Tennesseans have the best possible food truck experience.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      American Palate
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b7714032